"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Pagination;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _functions = require("../common/functions");
/**
 * Local Imports
*/

const Controls = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Controls",
  class: "pl-c1e47bwl"
});
const Paginate = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Paginate",
  class: "pl-p15zs0kk"
});
const PaginateCurrent = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "PaginateCurrent",
  class: "pl-pu4u8ns"
});
const PaginateTotal = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "PaginateTotal",
  class: "pl-pfs5bh0"
});
const Buttons = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Buttons",
  class: "pl-b16a3z3o"
});
const ButtonShared = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "ButtonShared",
  class: "pl-b1hcs2c8"
});
const NextButton = /*#__PURE__*/(0, _react2.styled)(ButtonShared)({
  name: "NextButton",
  class: "pl-n12irkho"
});
const PrevButton = /*#__PURE__*/(0, _react2.styled)(ButtonShared)({
  name: "PrevButton",
  class: "pl-pccpika"
});
const IconWrapper = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "IconWrapper",
  class: "pl-i4kz9w2"
});

/**
 * Pagination Component.
 *
 * @param {Object} props React props
 * @param {Number} props.currentPage Current page number
 * @param {Number} props.totalPage Total page number
 * @param {Function} props.forwardedPrev Controls Prev button
 * @param {Function} props.forwardedNext Controls Next button
 * @returns {React.ReactElement} Pagination Component
 * @public
 */
function Pagination({
  currentPage = 1,
  totalPage = 3,
  forwardedPrev,
  forwardedNext
}) {
  return /*#__PURE__*/_react.default.createElement(Controls, {
    "data-cy": "pagination"
  }, /*#__PURE__*/_react.default.createElement(_text.default.span, {
    as: "paragraph",
    size: 1
  }, /*#__PURE__*/_react.default.createElement(Paginate, null, /*#__PURE__*/_react.default.createElement(PaginateCurrent, null, (0, _functions.formatNumber)(currentPage)), /*#__PURE__*/_react.default.createElement(PaginateTotal, null, (0, _functions.formatNumber)(totalPage)))), /*#__PURE__*/_react.default.createElement(Buttons, null, /*#__PURE__*/_react.default.createElement(PrevButton, {
    className: currentPage === 1 && 'disabled',
    onClick: forwardedPrev
  }, /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-right"
  }))), /*#__PURE__*/_react.default.createElement(NextButton, {
    className: currentPage === totalPage && 'disabled',
    onClick: forwardedNext
  }, /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-right"
  })))));
}
Pagination.propTypes = {
  currentPage: _propTypes.default.number,
  totalPage: _propTypes.default.number,
  forwardedPrev: _propTypes.default.func,
  forwardedNext: _propTypes.default.func
};